import { useState, useEffect } from 'react'
import api, { IPageInfo, IEmployeeImportVersion, IEmployeeImportFailed } from '@api'
import {} from 'lodash'

export type Event = 'created' | 'updated' | 'destroyed' | 'failed'
export interface IEmployeeImportFailedWithId extends IEmployeeImportFailed {
  id: string
}

const allEvents: Event[] = ['created', 'updated', 'destroyed']

export default function useImportDetails(id: string, urlFilter?: Event) {
  const [details, setDetails] = useState<IEmployeeImportVersion[]>([])
  const [events, setEvents] = useState<Event[]>(
    urlFilter && urlFilter !== 'failed' ? [urlFilter] : []
  )
  const [loading, setLoading] = useState(false)
  const [loadingMore, setLoadingMore] = useState(false)
  const [pageInfo, setPageInfo] = useState<IPageInfo | null>(null)
  const [failed, setFailed] = useState<IEmployeeImportFailedWithId[]>([])
  const [createdAt, setCreatedAt] = useState('')
  const [importedBy, setImportedBy] = useState('')
  const [showFailed, setShowFailed] = useState(!!urlFilter && urlFilter === 'failed')

  const loadMore = () => {
    setLoadingMore(true)
    api.employee.import
      .details(id, pageInfo?.endCursor || '', events.length ? events : allEvents)
      .then(({ details: newDetails, pageInfo: newPageInfo }) => {
        setDetails([...details, ...newDetails])
        setPageInfo(newPageInfo)
        setLoading(false)
        setLoadingMore(false)
      })
  }

  const toggleEvent = (event: Event) => {
    if (events.find((e) => e === event)) {
      setEvents(events.filter((e) => e !== event))
    } else {
      setEvents([...events, event])
    }
  }

  useEffect(() => {
    setLoading(true)
    api.employee.import
      .details(id, null, events.length ? events : allEvents)
      .then(({ details, pageInfo, failed, createdAt, importedBy }) => {
        setDetails(details)
        setPageInfo(pageInfo)
        setImportedBy(importedBy)
        setCreatedAt(createdAt)
        if (failed) setFailed(failed?.map((f, i) => ({ ...f, id: `${i}` })))
        setLoading(false)
      })
  }, [events, id])

  return {
    details,
    pageInfo,
    failed,
    loading,
    loadMore,
    loadingMore,
    toggleEvent,
    events,
    importedBy,
    createdAt,
    showFailed,
    setShowFailed,
    onReset: () => {
      setEvents([])
      setShowFailed(false)
    },
  }
}
